import { render, staticRenderFns } from "./my_team.vue?vue&type=template&id=446e0dc5&scoped=true"
import script from "./my_team.vue?vue&type=script&lang=js"
export * from "./my_team.vue?vue&type=script&lang=js"
import style0 from "./my_team.vue?vue&type=style&index=0&id=446e0dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e0dc5",
  null
  
)

export default component.exports